import React from "react";
import "./productcart.scss";
import { useStateValue } from "../StateProvider";

const ProductCart = ({ id, title, image, price, rating, hideButton, qty }) => {
  const [{basket}, dispatch,] = useStateValue();

  const removeItem = () => {
    dispatch({
      type: "REMOVE_FROM_CART",
      id: id,
    });
  };

  const increaseQty = () => {
    dispatch({
      type: "INCREMENT",
      id: id,
    });
  };

  return (
    <div className="product_cart">
      <img src={image} alt={title} className="product_image" />
      <div className="productCart_info">
        <p className="productCart_title">{title}</p>
        <p className="productCart_details">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda{" "}
          <br />
          doloremque, recusandae officiis eveniet similique cupiditate molestiae{" "}
          <br />
          ratione odio dolorem cum dolore.
        </p>
        <p className="productCart_price">$ {price}</p>

        <div className="rating">
          <div className="productCart_rating">
            {Array(rating)
              .fill()
              .map((_) => (
                <img
                  src="https://img.icons8.com/material-outlined/16/000000/star--v3.png"
                  alt=""
                />
              ))}
          </div>
          
        </div>
        {!hideButton && (
          <button className="btn btn-danger" onClick={removeItem}>
            Remove
          </button>
        )}
      </div>
    </div>
  );
};

export default ProductCart;
